// Lista dos reason codes do Veriff
export type VeriffReasonCode =
	111 | 128 | 129 | 108 | 109 | 110 | 112 | 121 | 539 | 567 | 568 | 542 | 104 | 102 | 504 | 505 | 506 | 507 | 508 | 510 | 511 | 512 | 513 | 514 | 524 | 525 | 529 | 541 | 551 | 552 | 553 | 554 | 555 | 557 | 558 | 559 | 560 | 561 | 562 | 563 | 565 | 572 | 576 | 577 | 655 | 203 | 602 | 607 | 608 | 609 | 610 | 611 | 612 | 613 | 614 | 615 | 616 | 617 | 618 | 619 | 620 | 621 | 622 | 623 | 625 | 626 | 627 | 628 | 629 | 630 | 631 | 632 | 633 | 634 | 635 | 636 | 637 | 638 | 639 | 642 | 643 | 645 | 649 | 650 | 651 | 652 | 653 | 654 | 657 | 658 | 659 | 660 | 661 | 662 | 663 | 664 | 665 | 666 | 667 | 668 | 669 | 670 | 671 | 672 | 687 | 106 | 113 | 126 | 127 | 503 | 537 | 538 | 544 | 549 | 566 | 644 | 648 | 105 | 122 | 123 | 540 | 570 | 647 | 579 | 584 | 690 | 693 | 694 | 695;

/**
 * Utilitário para obter mensagem traduzida de um reasonCode do Veriff
 * Exemplo de uso:
 *   const msg = getVeriffReasonMessage(111, translateService);
 *   // Busca a chave 'KYC.VERIFF_REASON.111' no arquivo de idioma
 */
export function getVeriffReasonMessage(
	reasonCode: VeriffReasonCode,
	translate: { instant: (key: string) => string }
): string {
	const key = `KYC.VERIFF_REASON.${reasonCode}`;
	const translated = translate.instant(key);
	return translated !== key ? translated : key;
}
